import { gql, useMutation } from '@apollo/client'

import {
  ArtistRegisterSubscriptionMutation,
  ArtistRegisterSubscriptionMutationVariables,
  ConsolePlanDetailFragmentDoc,
  ConsoleProductDetailFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useMessage, useRouter, useTranslation } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { t } = useTranslation('consoleMembershipCreate')
  const { showMessage } = useMessage()
  const { router, routerPages } = useRouter()

  const [artistRegisterSubscription] = useMutation<
    ArtistRegisterSubscriptionMutation,
    ArtistRegisterSubscriptionMutationVariables
  >(ARTIST_REGISTER_SUBSCRIPTION)

  return {
    state: {
      artistId: user?.uid ?? '',
    },
    actions: {
      async onSubmit(inputs) {
        await artistRegisterSubscription({
          variables: { inputs },
        })
        showMessage(t('registerSubscriptionSuccess'))
        router.replace(routerPages.ConsoleMembership)
      },
    },
  }
})

const ARTIST_REGISTER_SUBSCRIPTION = gql`
  mutation ArtistRegisterSubscription($inputs: RegisterSubscriptionsInput!) {
    artistRegisterSubscriptions(inputs: $inputs) {
      id
      subscription {
        plans {
          ...ConsolePlanDetail
        }
        products {
          ...ConsoleProductDetail
        }
      }
    }
  }
  ${ConsolePlanDetailFragmentDoc}
  ${ConsoleProductDetailFragmentDoc}
`
